module.exports = __webpack_public_path__ + "img/IconAuths.5c2f6767.svg";